import { IDocuments, IPaginationResponse } from "../types";
import {
  IClassActionEvent,
  IClassActionEventParams,
  IClassActionEventDocumentsParams,
  IClassActionEventsParams,
} from "./types";
import { rootApi } from "../rootApi";

export const classActionEventApis = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    classActionEvents: builder.query<
      IPaginationResponse<IClassActionEvent>,
      IClassActionEventsParams
    >({
      query: ({ limit, ordering, offset, tab, issuerId }) => ({
        url: `class-action-events/`,
        params: {
          limit,
          ordering,
          offset,
          tab,
          issuer_id: issuerId || undefined,
        },
      }),
      providesTags: ["classActionEvents"],
    }),
    classActionEvent: builder.query<IClassActionEvent, IClassActionEventParams>(
      {
        query: ({ id }) => ({
          url: `class-action-events/${id}/`,
        }),
        providesTags: (_result, _, arg) => [
          { type: "classActionEvents", id: arg.id },
        ],
      }
    ),
    classActionEventDocuments: builder.query<
      IDocuments[],
      IClassActionEventDocumentsParams
    >({
      query: ({ id }) => ({
        url: `class-action-events/${id}/documents/`,
      }),
      providesTags: (_result, _, arg) => [
        { type: "classActionEventDocuments", id: arg.id },
      ],
    }),
  }),
});

export const {
  useClassActionEventQuery,
  useClassActionEventsQuery,
  useClassActionEventDocumentsQuery,
} = classActionEventApis;
